/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Cheque_status {
  CLEARED = "CLEARED",
  PENDING = "PENDING",
  UNCLEARED = "UNCLEARED",
}

export enum Claim_status {
  CLAIMED = "CLAIMED",
  UNCLAIMED = "UNCLAIMED",
}

export enum DeleteStatusEnum {
  DELETED = "DELETED",
  NOT_DELETED = "NOT_DELETED",
}

export enum Expiry_status {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
}

export enum NotificationType {
  DOCUMENT_SMS = "DOCUMENT_SMS",
  SYSTEM_BUSINESS = "SYSTEM_BUSINESS",
  SYSTEM_CLAIM = "SYSTEM_CLAIM",
  SYSTEM_EMAIL = "SYSTEM_EMAIL",
  SYSTEM_INSURER = "SYSTEM_INSURER",
  SYSTEM_OFFER = "SYSTEM_OFFER",
  SYSTEM_PLACEIT = "SYSTEM_PLACEIT",
  SYSTEM_REINSURER = "SYSTEM_REINSURER",
}

export enum OfferStatus {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  PENDING = "PENDING",
}

export enum Offer_status {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  PENDING = "PENDING",
}

export enum Payment_status {
  PAID = "PAID",
  PARTPAYMENT = "PARTPAYMENT",
  UNPAID = "UNPAID",
}

export enum PublishedStatus {
  PUBLISHED = "PUBLISHED",
  UNPUBLISHED = "UNPUBLISHED",
}

export enum Sent_status {
  SENT = "SENT",
  UNSENT = "UNSENT",
}

export enum TreatyType {
  NONPROPORTIONAL = "NONPROPORTIONAL",
  PROPORTIONAL = "PROPORTIONAL",
}

export enum status_type {
  APPROVED = "APPROVED",
  UNAPPROVED = "UNAPPROVED",
}

export interface ActivityFilter {
  device_type?: string | null;
  country?: string | null;
  region?: string | null;
  city?: string | null;
  date_from?: any | null;
  date_to?: any | null;
}

export interface ApproveOfferParticipantInput {
  offer_published_participant_id: string;
}

export interface Claim_data {
  offer_id: string;
  claim_amount: string;
  claim_date: string;
  claim_comment?: string | null;
  currency?: string | null;
  rate?: number | null;
}

export interface ClaimsFilter {
  offer_id?: string | null;
}

export interface DashboardOverviewInput {
  filter_by: (string | null)[];
  for?: string | null;
  from?: any | null;
  to?: any | null;
}

export interface Email_data {
  offer_id: string;
  reinsurer_id?: string | null;
  subject?: string | null;
  copied_emails?: (string | null)[] | null;
  message_content?: string | null;
  attachment?: string[] | null;
}

export interface Employee_data {
  employee_first_name: string;
  employee_last_name: string;
  employee_phonenumber: string;
  employee_email: string;
  employee_position: string;
  broker_id: string;
  broker_role_id: string;
}

export interface EndorsementFilters {
  offset: number;
  limit: number;
  search?: string | null;
  insurer_id?: string | null;
  approval_status?: status_type | null;
  class_of_business_id?: (string | null)[] | null;
  endorsement_status?: string | null;
  year?: string | null;
}

export interface EndorsementParticipationAndDeductions {
  participating_percentage?: number | null;
  wht?: number | null;
  nic?: number | null;
  brokerage?: number | null;
  commission?: number | null;
}

export interface ExtendedTreatyDetails {
  type?: TreatyType | null;
  proportional_detail?: TreatyProportionalDetailInput | null;
  np_detail?: TreatyNPDetailInput | null;
}

export interface Insurer_associate_data {
  insurersinsurer_id?: string | null;
  rep_first_name: string;
  rep_last_name: string;
  rep_primary_phonenumber: string;
  rep_secondary_phonenumber?: string | null;
  rep_email: string;
  position: string;
}

export interface Insurer_data {
  insurer_company_name: string;
  insurer_company_email: string;
  insurer_company_website?: string | null;
  street: string;
  suburb: string;
  region: string;
  country: string;
}

export interface LoginInput {
  username: string;
  password: string;
}

export interface NotificationFilter {
  notificationType?: NotificationType | null;
  notificationStartDate?: any | null;
  notificationEndDate?: any | null;
  search?: string | null;
}

export interface OfferAuditTrailInput {
  offerId: string;
  employeeId?: string | null;
}

export interface OfferClaimParticipantPaymentInput {
  offer_claim_participant: string;
  claim_share_payment_amount: number;
  payment_details: string;
  payment_comment?: string | null;
  payment_date: any;
}

export interface OfferFilters {
  insurer_id?: (string | null)[] | null;
  offset?: number | null;
  limit?: number | null;
  search?: string | null;
  status?: (string | null)[] | null;
  claim_status?: (string | null)[] | null;
  payment_status?: (string | null)[] | null;
  year?: string | null;
  offer_from?: string | null;
  class_of_business_id?: (string | null)[] | null;
  approval_status?: status_type | null;
  staff_id?: (string | null)[] | null;
  payment_type?: string | null;
  expiry_status?: string | null;
}

export interface OfferFiltersReinsurer {
  reinsurer_id?: string | null;
  offset?: number | null;
  limit?: number | null;
  status?: (string | null)[] | null;
  search?: string | null;
  year?: string | null;
}

export interface OfferPaymentInput {
  offer_id?: string | null;
}

export interface OfferTransactionThreadInput {
  reinsurer_id?: string | null;
  offer_published_participant_id?: string | null;
}

export interface Offer_data {
  class_of_business_id: string;
  insurer_id: string;
  employee_id: string;
  rate: number;
  commission: number;
  brokerage: number;
  facultative_offer: number;
  sum_insured: number;
  premium: number;
  policy_number?: string | null;
  insured_by: string;
  period_of_insurance_from: any;
  period_of_insurance_to: any;
  currency: string;
  offer_comment?: string | null;
  offer_details: string;
}

export interface Offer_edit_extra_charge_data {
  offer_id?: string | null;
  reinsurer_data: Reinsurer_extra_charge;
}

export interface Offer_extra_charge_data {
  offer_id?: string | null;
  reinsurer_data: Reinsurer_extra_charge[];
  participant_data: ParticipantReasonInput[];
}

export interface Offer_participant_payment_details {
  offer_participant_payment_id: string;
  paid_details: string;
  payment_comment: string;
}

export interface Offer_participant_payment_update {
  offer_id: string;
  offer_payment_id: string;
  offer_participants: (Offer_participant_payment_details | null)[];
}

export interface Offer_payment_data {
  offer_id: string;
  payment_amount: number;
  payment_details: string;
  Offer_payment_comment: string;
}

export interface Offer_payment_update_data {
  offer_payment_id: string;
  offer_id: string;
  payment_amount: number;
  payment_details: string;
  date_of_receipt?: any | null;
  Offer_payment_comment: string;
  payment_status?: string | null;
  auto_payment_receipt?: boolean | null;
}

export interface Pagination {
  offset?: number | null;
  limit?: number | null;
}

export interface ParticipantReasonInput {
  participant_id: string;
  reason?: string | null;
}

export interface PaymentDetails {
  payment_amount: number;
  treaty_id?: string | null;
  treaty_account_id?: string | null;
  payment_id?: string | null;
  payment_details: string;
  payment_comment?: string | null;
  payment_status: string;
  date_of_receipt?: any | null;
  cheque_clearance_status?: Cheque_status | null;
  uuid?: string | null;
  installment_type: number;
  auto_payment_receipt?: boolean | null;
}

export interface PortFolioEntry {
  withdrawal_percentage?: number | null;
  withdrawal_loss_percentage?: number | null;
  assumption_percentage?: number | null;
  assumption_loss_percentage?: number | null;
}

export interface ReBrokerAssociateInput {
  re_broker_assoc_first_name?: string | null;
  re_broker_assoc_last_name?: string | null;
  re_broker_assoc_primary_phone?: string | null;
  re_broker_assoc_secondary_phone?: string | null;
  re_broker_assoc_position?: string | null;
  re_broker_assoc_email?: string | null;
  re_brokersre_broker_id?: string | null;
}

export interface ReBrokerParticipationPercentageInput {
  treaty_id?: string | null;
  treaty_type?: TreatyType | null;
  re_broker_treaties_participation_id?: string | null;
  share_percentage?: number | null;
  admin_percentage?: number | null;
}

export interface Reinsurer_data {
  re_company_name: string;
  re_company_email: string;
  re_company_website?: string | null;
  street: string;
  suburb: string;
  region: string;
  country: string;
}

export interface Reinsurer_extra_charge {
  reinsurer_id?: string | null;
  reinsurer_participant_id?: string | null;
  nic_levy: number;
  withholding_tax: number;
  agreed_brokerage_percentage: number;
  agreed_commission: number;
}

export interface Reinsurer_rep_data {
  reinsurersreinsurer_id?: string | null;
  rep_first_name: string;
  rep_last_name: string;
  rep_primary_phonenumber: string;
  rep_secondary_phonenumber?: string | null;
  rep_email: string;
  position: string;
}

export interface Reinsurer_representative_data {
  reinsurer_id?: string | null;
  representatives_ids: string[];
}

export interface RejectOfferParticipantInput {
  offer_published_participant_id: string;
}

export interface SendOfferParticipationMessage {
  offer_published_id: string;
  offer_published_participant: string;
  message: string;
  firstname: string;
  lastname: string;
}

export interface SetOfferPublishInput {
  offer_id: string;
}

export interface TreatyData {
  treaty_details?: string | null;
  type?: string | null;
  currency?: string | null;
  order_hereon?: number | null;
  treaty_reference?: string | null;
  kek_reference?: string | null;
  insurersinsurer_id?: string | null;
  treaty_programstreaty_program_id?: string | null;
  treaty_associate_deductionstreaty_associate_deduction_id?: string | null;
  layer_limit?: string | null;
  installment_type?: number | null;
  m_and_d_premium?: number | null;
  treaty_extended_details?: ExtendedTreatyDetails | null;
}

export interface TreatyNPDetailInput {
  egrnpi?: number | null;
  adjustment_created?: boolean | null;
}

export interface TreatyProportionalDetailInput {
  treaty_id?: string | null;
  profit_commission?: number | null;
  re_mgmt_expense?: number | null;
  portfolio_entry?: PortFolioEntry | null;
  overall_gross_premium?: number | null;
  losses_outstanding?: number | null;
  prev_year_configuration?: string | null;
  portfolio_entry_compute?: number | null;
  ernpi?: number | null;
}

export interface Treaty_Email_data {
  treaty_id: string;
  subject?: string | null;
  copied_emails?: (string | null)[] | null;
  message_content?: string | null;
  attachment?: string[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
